import { render, staticRenderFns } from "./shidujilu.vue?vue&type=template&id=5240ec9a&scoped=true"
import script from "./shidujilu.vue?vue&type=script&lang=js"
export * from "./shidujilu.vue?vue&type=script&lang=js"
import style0 from "./shidujilu.vue?vue&type=style&index=0&id=5240ec9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240ec9a",
  null
  
)

export default component.exports